import { LANGUAGES } from '@containers/Admin/containers/UserPage/consts';
import { capitalizeScreamingCase } from '@utils/textHelpers';

export const SELECTOR_WIDTH: number = 240;

export const LANGUAGE_OPTIONS = [
  { label: capitalizeScreamingCase(LANGUAGES.HEBREW), value: 'HE' },
  { label: capitalizeScreamingCase(LANGUAGES.ENGLISH), value: 'EN' },
];
